(function () {
  'use strict';

  var galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach(function (gallery) {
    var mainImg = gallery.querySelector('#ProductMainImage');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-alt');
        if (fullSrc) mainImg.src = fullSrc;
        if (alt) mainImg.alt = alt;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
})();
